import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50">汗汗漫画</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href={siteInfo.social.weibo}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-base"></i>
              </a>
              <span
                className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="微信"
                title={`微信号：${siteInfo.social.wechat}`}
              >
                <i className="ri-wechat-line text-base"></i>
              </span>
              <a
                href={`https://wpa.qq.com/msgrd?v=3&uin=${siteInfo.social.qq}`}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="QQ"
              >
                <i className="ri-qq-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  恋爱漫画
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  奇幻漫画
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  动作漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          {/* Hot Categories */}
          <div>
            <h4 className="font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/thriller" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  悬疑漫画
                </Link>
              </li>
              <li>
                <Link to="/category/comedy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  搞笑漫画
                </Link>
              </li>
              <li>
                <Link to="/category/drama" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  剧情漫画
                </Link>
              </li>
              <li>
                <Link to="/category/bl" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  耽美漫画
                </Link>
              </li>
              <li>
                <Link to="/category/daily" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  日常漫画
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-foreground-400 mt-0.5"></i>
                <span className="text-sm text-foreground-400">{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-foreground-400 mt-0.5"></i>
                <span className="text-sm text-foreground-400">{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-foreground-400 mt-0.5"></i>
                <span className="text-sm text-foreground-400">{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 汗汗漫画 - 免费韩国漫画在线阅读平台。本站所有内容均来自合作伙伴授权。
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">
              关于我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}